module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showModal) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Rotinas Automáticas do eSocial")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "rotina-list"
  }, [(!_vm.loading && _vm.rotinas.length == 0) ? _c('div', {
    staticClass: "rotina-empty"
  }, [_vm._v("\n            Nenhuma rotina configurada.\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rotinas), function(rotina) {
    return _c('div', {
      key: rotina.signature,
      staticClass: "rotina-card",
      class: 'rotina-card--' + _vm.statusModifier(rotina)
    }, [_c('div', {
      staticClass: "rotina-card__header"
    }, [_c('div', {
      staticClass: "rotina-card__title"
    }, [_c('i', {
      class: _vm.rotinaIcon(rotina.signature)
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(rotina.label))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "placement": "top",
        "popper-class": "rotina-tooltip",
        "content": _vm.rotinaDescricao(rotina.signature)
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle rotina-card__help"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "rotina-card__actions"
    }, [(rotina.toggleavel) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "placement": "top",
        "popper-class": "rotina-tooltip",
        "content": rotina.ativo ? 'Desativar rotina' : 'Ativar rotina'
      }
    }, [_c('el-switch', {
      attrs: {
        "value": rotina.ativo,
        "active-value": true,
        "inactive-value": false,
        "disabled": _vm.togglingSignature == rotina.signature
      },
      on: {
        "change": function($event) {
          return _vm.toggleAtivo(rotina, $event)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rotina-card__status",
      class: 'rotina-card__status--' + _vm.statusModifier(rotina)
    }, [_c('i', {
      class: _vm.statusIcon(rotina)
    }), _vm._v(" " + _vm._s(_vm.statusLabel(rotina)) + "\n                ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "rotina-card__meta"
    }, [_c('div', {
      staticClass: "rotina-meta"
    }, [_c('span', {
      staticClass: "rotina-meta__label"
    }, [_vm._v("Última execução")]), _vm._v(" "), _c('span', {
      staticClass: "rotina-meta__value"
    }, [_vm._v("\n                  " + _vm._s(rotina.ultima_execucao ? _vm.toDate(rotina.ultima_execucao) : "Nunca executado") + "\n                ")]), _vm._v(" "), (rotina.ultima_execucao) ? _c('span', {
      staticClass: "rotina-meta__relative"
    }, [_vm._v(_vm._s(_vm.fromNow(rotina.ultima_execucao)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "rotina-meta"
    }, [_c('span', {
      staticClass: "rotina-meta__label"
    }, [_vm._v("Próxima execução")]), _vm._v(" "), _c('span', {
      staticClass: "rotina-meta__value"
    }, [_vm._v(_vm._s(_vm.toDate(rotina.proxima_execucao)))]), _vm._v(" "), _c('span', {
      staticClass: "rotina-meta__relative"
    }, [_vm._v(_vm._s(_vm.fromNow(rotina.proxima_execucao)))])]), _vm._v(" "), (!rotina.processando && rotina.pendente !== null) ? _c('div', {
      staticClass: "rotina-meta"
    }, [_c('span', {
      staticClass: "rotina-meta__label"
    }, [_vm._v("\n                  Pendente\n                  "), (rotina.signature == 'command:esocial.gerarLote') ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "placement": "top",
        "popper-class": "rotina-tooltip",
        "content": "Estimativa: conta eventos sem lote/recibo em qualquer layout, sem aplicar o filtro específico de cada um."
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle rotina-card__help"
    })]) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "rotina-meta__value"
    }, [_vm._v(_vm._s(rotina.pendente))])]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "rotina-card__toggle",
      on: {
        "click": function($event) {
          return _vm.toggleHistorico(rotina.signature)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.historico == rotina.signature ? 'fa-chevron-up' : 'fa-chevron-down'
    }), _vm._v("\n              " + _vm._s(_vm.historico == rotina.signature ? "Ocultar histórico" : "Ver histórico") + "\n            ")]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "esocial-modal-fade"
      }
    }, [(_vm.historico == rotina.signature) ? _c('div', {
      staticClass: "rotina-historico"
    }, [(_vm.loadingHistorico) ? _c('div', {
      staticClass: "rotina-historico__loading"
    }, [_c('i', {
      staticClass: "fa fa-refresh fa-spin"
    }), _vm._v(" Carregando histórico...\n                ")]) : (_vm.historicoItens.length == 0) ? _c('div', {
      staticClass: "rotina-historico__empty"
    }, [_vm._v("\n                  Nenhuma execução registrada ainda.\n                ")]) : _c('table', {
      staticClass: "rotina-historico-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Horário")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.resumoColunas(_vm.historicoItens)), function(col) {
      return _c('th', {
        key: col
      }, [_vm._v(_vm._s(col))])
    })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoItens), function(item) {
      return _c('tr', {
        key: item.id,
        staticClass: "rotina-historico-table__row",
        class: _vm.historicoRowClass(item),
        on: {
          "click": function($event) {
            return _vm.openDetalhe(item)
          }
        }
      }, [_c('td', {
        staticClass: "rotina-historico-table__date"
      }, [_vm._v(_vm._s(_vm.toDate(item.updated_at)))]), _vm._v(" "), _c('td', {
        staticClass: "rotina-historico-table__status"
      }, [_c('i', {
        staticClass: "fa",
        class: _vm.historicoStatusIcon(item)
      }), _vm._v("\n                        " + _vm._s(_vm.historicoStatusLabel(item)) + "\n                      ")]), _vm._v(" "), _vm._l((_vm.resumoColunas(_vm.historicoItens)), function(col) {
        return _c('td', {
          key: col,
          staticClass: "rotina-historico-table__num"
        }, [_vm._v("\n                        " + _vm._s(_vm.resumoValor(item, col)) + "\n                      ")])
      })], 2)
    }), 0)])]) : _vm._e()])], 1)
  })], 2)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.detalheItem) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeDetalhe($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Detalhes da execução")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": _vm.closeDetalhe
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "rotina-detalhe"
  }, [_c('div', {
    staticClass: "rotina-detalhe__date"
  }, [_vm._v(_vm._s(_vm.toDate(_vm.detalheItem.updated_at)))]), _vm._v(" "), _c('div', {
    staticClass: "rotina-detalhe__msg",
    class: {
      'rotina-detalhe__msg--error': _vm.detalheItem.executado == 0
    }
  }, [_vm._v("\n            " + _vm._s(_vm.detalheItem.msg || "-") + "\n          ")]), _vm._v(" "), (_vm.resumoDe(_vm.detalheItem).length) ? _c('div', {
    staticClass: "rotina-historico__resumo"
  }, _vm._l((_vm.resumoDe(_vm.detalheItem)), function(r, idx) {
    return _c('span', {
      key: idx,
      staticClass: "rotina-historico__resumo-item"
    }, [_vm._v("\n              " + _vm._s(r.label) + ": "), _c('b', [_vm._v(_vm._s(r.valor))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.errosDe(_vm.detalheItem).length) ? _c('div', {
    staticClass: "rotina-historico__erros"
  }, _vm._l((_vm.errosDe(_vm.detalheItem)), function(erro, idx) {
    return _c('span', {
      key: idx,
      staticClass: "rotina-historico__erro"
    }, [_vm._v("\n              " + _vm._s(_vm.formatErro(erro)) + "\n            ")])
  }), 0) : _vm._e()])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb65ac26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/includes/agendamento.vue
// module id = 1597
// module chunks = 45